import { render } from "./TestAudio.vue?vue&type=template&id=f2b45f84&scoped=true"
import script from "./TestAudio.vue?vue&type=script&lang=js"
export * from "./TestAudio.vue?vue&type=script&lang=js"

import "./TestAudio.vue?vue&type=style&index=0&id=f2b45f84&lang=css"
import "./TestAudio.vue?vue&type=style&index=1&id=f2b45f84&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\eNotary.SPA\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2b45f84"]])

export default __exports__